<template>
  <div class="table-actions">
    <div @click="toggleDropdown">
      <div class="icon-container">
        <BaseIcon class="dropdown-icon" name="menu-icon" iconColor="white" />
      </div>

      <transition name="fade">
        <div v-if="dropdownOpen" class="table-actions-list">
          <ul class="actions-dropdown-menu">
            <li
              class="cursor: pointer;"
              v-for="option in dropdownOptions"
              :key="option.id"
              @click="selectOption(option)"
            >
              {{ option.label }}
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableActions',

  data() {
    return {
      dropdownOpen: false,
      dropdownOptions: [],
      selectedOption: null,
    };
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  created() {
    this.dropdownOptions = [
      { id: 'view', label: this.$t('aws.viewServices') },
      { id: 'edit', label: this.$t('aws.editConfiguration') },
      { id: 'forceUpdate', label: this.$t('aws.forceUpdate') },
      { id: 'delete', label: this.$t('aws.deleteOption') },
    ];
  },

  mounted() {
    // Add a global click event listener to close dropdown on outside click
    document.addEventListener('click', this.closeDropdownOnOutsideClick);
  },

  beforeUnmount() {
    // Clean up the click event listener when component is destroyed
    document.removeEventListener('click', this.closeDropdownOnOutsideClick);
  },

  methods: {
    toggleDropdown() {
      // Emit event to parent to close other dropdowns
      this.$emit('close-other-dropdowns');

      // Toggle current dropdown
      this.dropdownOpen = !this.dropdownOpen;
    },

    selectOption(option) {
      this.selectedOption = option;
      this.dropdownOpen = false;
      this.$emit(option.id, {
        item: this.item,
        name: this.item.connectionName,
        subscriptionId: this.item.subscriptionId,
      });
    },

    closeDropdownOnOutsideClick(event) {
      // Close dropdown if clicked outside the dropdown menu
      if (!this.$el.contains(event.target)) {
        this.dropdownOpen = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table-actions {
  @include flex-center-justify(space-between);
  gap: 1.25rem;
  position: absolute;
  cursor: pointer;
}

.actions-dropdown-menu {
  font-family: $regular;
  list-style-type: none;
  @include flex-column;
  gap: 0.625rem;
  left: -1.5625rem;
  margin-top: 0.625rem;
  position: relative;
}

.table-actions-list {
  position: absolute;
  background-color: #3d3f43;
  padding: 0.25rem;
  z-index: 100;
  width: 12.375rem;
  border-radius: 0.25rem;
}

.dropdown-menu li {
  padding: 0.5rem;
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $color-dark-gray;
  width: 22px;
  height: 20px;
  border-radius: 4px;
  position: relative;
}

.dropdown-icon {
  transform: rotate(90deg) scale(0.7);
  position: absolute;
  left: 11px;
}
</style>
